const Blockade = () => {
  return (
    <g>
      <g>
        <path d="M3437.25,295.76a121.22,121.22,0,0,0-78.83-78.83L3509.18,145Z"/>
        <path d="M3495,159.16l-57.09,119.63a129.12,129.12,0,0,0-62.55-62.55L3495,159.16m28.3-28.31-186.06,88.77h0c49,4.22,93.07,48.28,97.28,97.29h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M3790.5,765.76a121.22,121.22,0,0,0-78.83-78.83L3862.43,615Z"/>
        <path d="M3848.27,629.16,3791.19,748.8a129.16,129.16,0,0,0-62.56-62.56l119.64-57.08m28.31-28.3-186.06,88.77h0c49,4.22,93.07,48.28,97.28,97.29h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M3460.06,1464.38a121.17,121.17,0,0,0-78.82-78.83L3532,1313.63Z"/>
        <path d="M3517.84,1327.78l-57.08,119.64a129.12,129.12,0,0,0-62.56-62.56l119.64-57.08m28.3-28.31-186.06,88.78h0c49,4.22,93.06,48.28,97.27,97.28h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M3334.21,2285.81a121.23,121.23,0,0,0-78.83-78.82l150.75-71.93Z"/>
        <path d="M3392,2149.21l-57.08,119.64a129.16,129.16,0,0,0-62.56-62.56L3392,2149.21m28.31-28.3-186.07,88.77h0c49,4.22,93.06,48.28,97.27,97.29h0l88.78-186.06Z"/>
      </g>
      <g>
        <path d="M3762.84,3240.18a121.22,121.22,0,0,0-78.83-78.83l150.75-71.92Z"/>
        <path d="M3820.61,3103.58l-57.08,119.64a129.08,129.08,0,0,0-62.56-62.56l119.64-57.08m28.31-28.31L3662.85,3164h0c49,4.21,93.06,48.28,97.27,97.28h0l88.78-186.06Z"/>
      </g>
      <g>
        <path d="M2314.93,3705.4a121.22,121.22,0,0,0-78.83-78.83l150.76-71.93Z"/>
        <path d="M2372.7,3568.8l-57.08,119.63a129.1,129.1,0,0,0-62.56-62.55l119.64-57.08m28.31-28.31L2215,3629.26h0c49,4.22,93.07,48.28,97.28,97.29h0L2401,3540.49Z"/>
      </g>
      <g>
        <path d="M1500.6,3798.43a121.22,121.22,0,0,0-78.83-78.83l150.75-71.93Z"/>
        <path d="M1558.37,3661.83l-57.08,119.63a129.1,129.1,0,0,0-62.56-62.55l119.64-57.08m28.31-28.31-186.07,88.77h0c49,4.22,93.06,48.28,97.27,97.29h0l88.78-186.06Z"/>
      </g>
      <g>
        <path d="M974.87,3147.15a121.23,121.23,0,0,0-78.82-78.83l150.75-71.93Z"/>
        <path d="M1032.65,3010.55l-57.08,119.63A129.18,129.18,0,0,0,913,3067.63l119.64-57.08m28.3-28.31L874.89,3071h0c49,4.21,93.07,48.28,97.28,97.28h0L1061,2982.24Z"/>
      </g>
      <g>
        <path d="M266.33,3046.67a121.19,121.19,0,0,0-78.82-78.82l150.75-71.93Z"/>
        <path d="M324.11,2910.07,267,3029.71a129.14,129.14,0,0,0-62.56-62.55l119.64-57.09m28.3-28.3-186.06,88.77h0c49,4.22,93.06,48.28,97.27,97.29h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M531.65,2242.91a121.22,121.22,0,0,0-78.83-78.83l150.75-71.93Z"/>
        <path d="M589.42,2106.31,532.34,2226a129.12,129.12,0,0,0-62.56-62.56l119.64-57.08m28.3-28.31-186.06,88.77h0c49,4.21,93.06,48.28,97.27,97.28h0L617.72,2078Z"/>
      </g>
      <g>
        <path d="M173.3,1226.79a117.64,117.64,0,0,0-29.8-49,117.72,117.72,0,0,0-49-29.82L245.23,1076Z"/>
        <path d="M231.08,1090.19,174,1209.82a129.14,129.14,0,0,0-62.56-62.55l119.64-57.08m28.3-28.31L73.32,1150.65h0c49,4.22,93.07,48.28,97.28,97.29h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M960.54,596.48a121.19,121.19,0,0,0-78.82-78.82l150.75-71.93Z"/>
        <path d="M1018.32,459.88,961.24,579.52A129.2,129.2,0,0,0,898.68,517l119.64-57.08m28.3-28.3L860.56,520.35h0c49,4.22,93.06,48.28,97.27,97.29h0l88.77-186.06Z"/>
      </g>
      <g>
        <path d="M1471.87,229.55A121.22,121.22,0,0,0,1393,150.72L1543.8,78.8Z"/>
        <path d="M1529.64,93l-57.08,119.64A129.12,129.12,0,0,0,1410,150L1529.64,93M1558,64.64l-186.06,88.78h0c49,4.22,93.07,48.28,97.28,97.29h0L1558,64.64Z"/>
      </g>
    </g>
  )
}

export default Blockade;
